import { useAdDetails } from './useAdDetails';
import { useAuthStore } from '@/store/useAuthStore';

export function useIsAuthor() {
  const { userId } = useAuthStore(state => state);
  const { adDetails } = useAdDetails();
  return userId === adDetails?.user?.id;
}
